import React from 'react';
import Image from "next/image";
import styles from "../../pages/upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import downloadicon from "../../assets/images/download.png";
function optionalplus() {
    const feestructure4=[
        {date:"27.07.2024",cont:"Weekend",cont1:"History",cont2:"02:30 pm to 07:30 pm"}
      ];
      return(
       
<div className={`${styles.oneplusbox}`}>
  {/*  
  <div className="container">
    <h4 className={`${styles.plus} mb-0 `}>History Optional 'Plus'</h4>
   
      <div className="row ">
      
          <div className=" col-6 col-md-6 col-lg-4 col-xl-4 pt-2 "> 
            <p className={`${styles.para} `}>One-year History Optional Plus Program</p> 
              <span className={`${styles.para} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>35,000</span></span>
          </div>

          <div className="col-6 col-md-6 col-lg-4 col-xl-4    pt-2 ">
            <ul>
              <li className={`${styles.acheiverrank} `}><span className={`${styles.dot} pe-2`}>*</span>Weekend - Online</li>
              <li className={`${styles.acheiverrank} `}><span className={`${styles.dot} pe-2`}>*</span>27-07-2024</li>
              <li className={`${styles.acheiverrank} `}><span className={`${styles.dot} pe-2`}>*</span>02:30 pm to 07:30 pm</li> <br/>
              <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink} `}><button type="button" className={`${styles.plusbutton} `}>Pay Here</button></a>
            </ul>
          </div>

          <div className="col-6 col-md-6 col-lg-4  col-xl-4  pb-2 ">
              <a href="https://www.shankariasacademy.com/pdf/Optional-Plus/Optional-Plus-History-Brochure.pdf" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.optionalbutton}`}><Image src={downloadicon} alt="download icon" />&nbsp; Download Brochure</button></a>
           </div>
      </div>
  </div> */}
          
                
                {/* <div className="col ps-0 ps-xl-0 p-xl-0">
            <div className="table-responsive text-nowrap">
          <table className="table ">
            <tbody>
            {feestructure4.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont2}</td>
              </tr>
              ))}
             
            </tbody>
          </table>
          </div>
          </div> */}  
              
</div>
          
      )
}

export default optionalplus;